import * as React from 'react';

import {
  ListItemFolderProps,
  QuizWorkspaceListItemFolder,
} from '~teacher/components/QuizWorkspaceList/QuizWorkspaceListItemFolder';
import {
  ListItemQuizProps,
  QuizWorkspaceListItemQuiz,
} from '~teacher/components/QuizWorkspaceList/QuizWorkspaceListItemQuiz';
import {
  ListItemWorkspaceProps,
  QuizWorkspaceListItemWorkspace,
} from '~teacher/components/QuizWorkspaceList/QuizWorkspaceListItemWorkspace';

import { assertUnreachable } from '../../../util/assertUnreachable';

export type ListItemProps =
  | ListItemQuizProps
  | ListItemFolderProps
  | ListItemWorkspaceProps;

export function QuizWorkspaceListItem(props: ListItemProps) {
  switch (props.type) {
    case 'folder':
      return <QuizWorkspaceListItemFolder {...props} />;
    case 'quiz':
      return <QuizWorkspaceListItemQuiz {...props} />;
    case 'workspace':
      return <QuizWorkspaceListItemWorkspace {...props} />;
  }
  return assertUnreachable(props);
}
